import React, { useCallback } from 'react'
import { useInfiniteQueryPaymentHistory } from '@/api/payment/queries'
import { PaymentHistory } from '@/types/Payment'
import { PaymentItem } from './PaymentItem'
import { InfiniteScrollList } from '@/components/InfiniteScrollList'
import { ListSkeleton } from '@/components/ListSkeleton'
import { PaymentHistoryFilters } from '@/api/payment/types'

export interface PaymentListProps {
  filters?: PaymentHistoryFilters
}

export const PaymentList: React.FC<PaymentListProps> = ({ filters = {} }) => {
  const query = useInfiniteQueryPaymentHistory(filters)

  const renderItem = useCallback((item: PaymentHistory) => (
    <PaymentItem transaction={item} />
  ), [])

  const getKey = useCallback((item: PaymentHistory) => item.id, [])

  return (
    <InfiniteScrollList<PaymentHistory>
      query={query}
      renderItem={renderItem}
      getKey={getKey}
      skeleton={<ListSkeleton.PaymentItem />}
      emptyTitle="Nenhuma transação"
      emptyMessage="Você ainda não possui histórico de pagamentos."
    />
  )
}
